import { useCallback } from "react";
import {
  MelcoModelsUserProductPermissions,
  RolesPermissionsApi,
  useAPIAction,
} from "melco-shared-logic";

export interface UserProductRolesAssignActionButtonInterface {
  melcoModelsUserProductPermissions?: MelcoModelsUserProductPermissions;
}

export const useUserProductRolesAssign = (
  userIdToAssignUpdateProductRoles: string
) => {
  const [userProductRolesAssign] = useAPIAction(
    RolesPermissionsApi,
    async (
      api,
      userProductRolesAssignActionDetails: UserProductRolesAssignActionButtonInterface
    ) => {
      console.log(
        "user data ",
        JSON.stringify({
          userId: userIdToAssignUpdateProductRoles,
          melcoModelsUserProductPermissions:
            userProductRolesAssignActionDetails.melcoModelsUserProductPermissions,
        })
      );
      await api.userAccountEditPermission({
        userId: userIdToAssignUpdateProductRoles,
        controlcenterMelcoModelsUserProductPermissions:
          userProductRolesAssignActionDetails.melcoModelsUserProductPermissions,
      });

      return {
        successMessages: [{ message: "default" }],
        // data,
      };
    },
    {
      //  defaultApiConfigOptions: {impersonationForId: userIdToAssignUpdateProductRoles},
      translationPrefix: "users.tabs.permissions.actions.assignrole",
    }
  );

  return useCallback(
    async (
      userProductRolesAssignActionDetails: UserProductRolesAssignActionButtonInterface
    ) => {
      try {
        await userProductRolesAssign(userProductRolesAssignActionDetails);
      } catch (e) {
        // error handling is already done in useAPIAction
        return { success: false };
      }

      return { success: true };
    },
    [userProductRolesAssign]
  );
};
